function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { computed, defineComponent, inject, onUnmounted, reactive, watch, h } from '@vue/composition-api';
import { TABS_KEY } from '../tabs';
import { withInstall } from '../util';
import { createNamespace } from '../util/create';
import "../style/components/tabs.css";

var _createNamespace = createNamespace('tab'),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

export var tabProps = {
  title: {
    type: String,
    required: false
  },
  name: {
    type: [String, Number],
    required: true
  },
  disabled: {
    type: Boolean,
    "default": false
  }
};
var Tab = defineComponent({
  name: name,
  props: tabProps,
  slots: ['default'],
  emits: ['change'],
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        root = _ref.root;
    var tabsProvide = inject(TABS_KEY, null);

    if (!tabsProvide) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[metaUI] <Tab> must be a child component of <Tabs>.');
      }

      return;
    }

    var state = reactive({
      inited: false
    });

    var getName = function getName() {
      var _props$name;

      return (_props$name = props.name) !== null && _props$name !== void 0 ? _props$name : '';
    };

    var active = computed(function () {
      var isActive = tabsProvide.props.active === getName();

      if (isActive && !state.inited) {
        init();
      }

      return isActive;
    });

    var init = function init() {
      state.inited = true;

      if (tabsProvide.props.lazyRender) {
        root.$nextTick(function () {
          tabsProvide.onRendered(getName(), props.title);
        });
      }
    };

    watch(props, function () {
      tabsProvide.updateChildrenTablist();
    }, {
      immediate: true
    });
    onUnmounted(function () {
      tabsProvide.updateChildrenTablist();
    });
    return function () {
      var _slots$default;

      var swiperable = tabsProvide.props.swiperable;
      var swiperType = tabsProvide.props.swiperType;
      var shouldRender = state.inited || !tabsProvide.props.lazyRender;
      var Content = shouldRender ? (_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots) : null;
      return swiperable && swiperType !== 3 ? h("div", {
        "class": {
          'm-tab__pane-wrapper': true,
          'm-tab__pane--inactive': !active.value
        }
      }, [h("div", {
        "class": {
          'm-tab__pane': true,
          'm-tab__pane--hide': !state.inited
        }
      }, [Content])]) : h("div", {
        "class": {
          'm-tab__pane': true,
          'm-tab__pane--hide': !active.value
        }
      }, [Content]);
    };
  }
});
withInstall(Tab);
export default Tab;